import { AbstractEntity } from "../AbstractEntity";
export default class ClientDevice extends AbstractEntity {
    name;
    ip = null;
    systemTime = null;
    timeInSync = null;
    hasAlerts = null;
    constructor(clientDevice = {}) {
        super();
        Object.assign(this, clientDevice);
    }
}
//# sourceMappingURL=ClientDevice.js.map